import domtoimage from '../tools/dom-to-image';
import jsPDF from "jspdf"
export default  {
    methods: {
        async generateReportPDF(title="", subtitle=null, whiteMode= false, brandName=null, disableCoverPage = false, customLogo = null){

            ////////////////////////////////////////////////////////////
            // pre-defined variables
            ////////////////////////////////////////////////////////////
            if(!subtitle){
                subtitle=""
            }
            if(!brandName){
                brandName=""
            }
            let backgroundColor=whiteMode ? "#FFFFFF" : "#424242"
            let textColor=whiteMode ? "#424242" : "#FFFFFF"
            // create jsPDF object
            let doc = new jsPDF({ compress:true })

            // page max height, width
            let max_height = doc.internal.pageSize.getHeight();
            let max_width = doc.internal.pageSize.getWidth();

            ////////////////////////////////////////////////////////////
            // get elements from html
            ////////////////////////////////////////////////////////////

            // get chart from html
            let graphs_wrap = document.getElementById("carnotMainContent").getElementsByClassName("carnot-custom-view")[0].getElementsByClassName("layout row wrap")[0]
            let graphs = graphs_wrap.children
            
            ////////////////////////////////////////////////////////////
            // customise pdf
            ////////////////////////////////////////////////////////////

            // custom header, footer content
            let header = brandName
            let footer = subtitle? title+" - "+subtitle : title
            let page_num = 1

            // custom coordiante of logo, header, footer, title, subtitle
            let logo_x = 10
            let logo_y = 5
            let header_x = 20
            let header_y = 10
            let footer_x = 10
            let footer_y = max_height-10
            let page_num_x = max_width-20
            let page_num_y = max_height-10
            let title_x = 20
            let title_y = max_height/2
            let subtitle_x = 20
            let subtitle_y = max_height/2 + 10
            
            // custom boundary for content
            let content_x_min = 10
            let content_x_max = max_width-10
            let max_pdf_width = max_width-20
            let content_y_min = 20
            let content_y_max = max_height-20
            
            // customise max canvas size (with a small buffer)
            let max_canvas_width = graphs_wrap.clientWidth + 10

            // custom width ratio
            let img_width_ratio = max_pdf_width / max_canvas_width

            // custom pdf text color => white
            doc.setTextColor(textColor)

            // custom pdf background color => print a big rectangle as the background
            function setPDFBackground(){
                doc.setFillColor(backgroundColor);
                doc.rect(0, 0, max_width, max_height, 'F'); 
            }

            // custom add image function
            function loadLogo() {
                return new Promise((resolve, reject) => {
                    let img = new Image;         
                    img.onload = () => resolve(img);
                    img.onerror = reject;
                    img.src = customLogo
                })
            }

            // add new page function
            async function PDFAddNewPage() {
                // add new page
                doc.addPage()
                // set backgorund color
                setPDFBackground()
                // add header, footer
                if(customLogo&&customLogo!=="") {
                    await loadLogo().then(img => doc.addImage(img, "PNG", logo_x, logo_y, 7, 7, undefined, "FAST"))
                }
                doc.setFontSize(12)
                doc.text(header,header_x,header_y)
                doc.setFontSize(8)
                doc.text(footer,footer_x,footer_y)
                doc.text("page "+(++page_num),page_num_x,page_num_y)
            }

            ////////////////////////////////////////////////////////////
            // pdf content
            ////////////////////////////////////////////////////////////            
            if(disableCoverPage){
                setPDFBackground()
                if(customLogo&&customLogo!=="") {
                    await loadLogo().then(img => doc.addImage(img, "PNG", logo_x, logo_y, 7, 7, undefined, "FAST"))
                }
                doc.setFontSize(12)
                doc.text(header,header_x,header_y)
                doc.setFontSize(8)
                doc.text(footer,footer_x,footer_y)
                doc.text("page "+(page_num),page_num_x,page_num_y)
            } else {
                // pdf cover page add background
                setPDFBackground()
                if(customLogo&&customLogo!=="") {
                    await loadLogo().then(img => doc.addImage(img, "PNG", logo_x, logo_y, 7, 7, undefined, "FAST"))
                }
                // pdf cover page add header
                doc.setFontSize(12)
                doc.text(header,header_x,header_y)
                // pdf cover page add title, subtitle
                doc.setFontSize(18)
                doc.text(title,title_x,title_y)
                // pdf cover page add subtitle
                doc.setFontSize(12)
                doc.text(subtitle,subtitle_x,subtitle_y)
                // pdf cover page add footer
                doc.setFontSize(8)
                doc.text(footer,footer_x,footer_y)
                doc.text("page "+page_num,page_num_x,page_num_y)

                PDFAddNewPage()
            }

            // pdf append graphs
            let pX_head = content_x_min
            let pY_head = content_y_min
            let pY_tail = pY_head
            
            // loop to add image
            for (let i = 0; i < graphs.length; i++) {
                try {
                    // generate image URL
                    let imgURL = await domtoimage.toJpeg(graphs[i], {
                        quality: 0.95 ,
                        bgcolor:backgroundColor
                    })

                    // resize image
                    let img_width = graphs[i].offsetWidth * img_width_ratio
                    let img_height = graphs[i].offsetHeight * img_width / graphs[i].offsetWidth

                    // check if exceed page width boundary
                    if (pX_head + img_width > content_x_max) {
                        pY_head = pY_tail
                        pX_head = content_x_min
                    }

                    // set the y coordinate of new row
                    if (pY_head + img_height > pY_tail) pY_tail = pY_head + img_height + 5

                    // page break
                    if (pY_tail > content_y_max || (i > 0 && graphs[i - 1].className.indexOf('page-break') > -1)) {
                        PDFAddNewPage()
                        pY_head = content_y_min
                        pY_tail = pY_head + img_height + 5
                    }

                    // apend image
                    doc.addImage(imgURL, 'JPEG', pX_head, pY_head, img_width, img_height, undefined, "FAST")
                    pX_head += img_width
                } catch (error) {
                    console.error(error);
                }

            }

            // export pdf (wait 1s for async functions to finish execution)
            setTimeout(() => doc.save(title+".pdf"), 1000)
        }
    }
}
